// 任务运行状态灯：一眼看出还在跑、停下等人、还是结束了。
// 运行中 = 绿色呼吸；等扫码 / 等审批 / 暂停等你决定 = 红橙色外圈扩散（要人处理）；结束 = 静止。旁边写「上次动作 N 秒前」，久了没动静变黄提醒
import { useEffect, useState } from "react";
import type { TaskStatus } from "@csp/shared";

type Kind = "run" | "wait" | "attn" | "idle" | "ok" | "bad";

const META: Record<TaskStatus, { kind: Kind; text: string }> = {
  running: { kind: "run", text: "运行中" },
  queued: { kind: "wait", text: "排队中" },
  waiting_scan: { kind: "attn", text: "等你扫码" },
  review_required: { kind: "attn", text: "等你审批" },
  blocked: { kind: "attn", text: "已暂停 · 等你决定" },
  done: { kind: "ok", text: "已完成" },
  failed: { kind: "bad", text: "失败" },
  cancelled: { kind: "idle", text: "已取消" },
  archived: { kind: "idle", text: "已归档" },
  draft: { kind: "idle", text: "未开始" },
  ready: { kind: "idle", text: "未开始" },
};

/** 运行中超过这么久没有新动作，提示可能卡住 */
const QUIET_MS = 3 * 60_000;

function ago(ms: number): string {
  const s = Math.max(0, Math.round(ms / 1000));
  if (s < 60) return `${s} 秒前`;
  const m = Math.floor(s / 60);
  return m < 60 ? `${m} 分钟前` : `${Math.floor(m / 60)} 小时前`;
}

export function RunPulse({ status, lastAt, runNo }: { status: TaskStatus; lastAt: string | null; runNo: number | null }) {
  const meta = META[status];
  const live = meta.kind === "run" || meta.kind === "attn" || meta.kind === "wait";
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!live) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [live]);
  const idleMs = lastAt ? now - new Date(lastAt).getTime() : null;
  const quiet = meta.kind === "run" && idleMs !== null && idleMs > QUIET_MS;
  return (
    <span className={`run-pulse rp-${quiet ? "quiet" : meta.kind}`} role="status" data-testid="run-pulse" title={quiet ? "运行中，但很久没有新动作，可能卡住了，看看事件记录" : undefined}>
      <i aria-hidden="true" />
      <b>{meta.text}</b>
      {live && idleMs !== null && <span className="rp-ago">{quiet ? `已 ${ago(idleMs).replace("前", "")}没有新动作` : `上次动作 ${ago(idleMs)}`}</span>}
      {runNo !== null && <span className="rp-no">第 {runNo} 次运行</span>}
    </span>
  );
}
